import { render, staticRenderFns } from "./adminTabUser.vue?vue&type=template&id=0c2e3d58&scoped=true&"
import script from "./adminTabUser.vue?vue&type=script&lang=ts&"
export * from "./adminTabUser.vue?vue&type=script&lang=ts&"
import style0 from "./adminTabUser.vue?vue&type=style&index=0&id=0c2e3d58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2e3d58",
  null
  
)

export default component.exports